import {BehaviorSubject} from "rxjs";
import {useSubjectSnapshot} from "features/core/subject.hooks";

const BulletinSnapshot = new BehaviorSubject<Record<string, any>>({});
const BulletinCardIdSnapshot = new BehaviorSubject<Record<string, any>>({});
const DailyRacesSnapshot = new BehaviorSubject<any[]>([]);
const HippodromesMapSnapshot = new BehaviorSubject<Record<string, any>>({});
const AvailableHippodromes = new BehaviorSubject<any[]>([]);
const AvailableFOBHippodromes = new BehaviorSubject<any[]>([]);
const AvailableLongtermHippodromes = new BehaviorSubject<any[]>([]);

export const useBulletin = () => useSubjectSnapshot(BulletinSnapshot, () => BulletinSnapshot.getValue());
export const useBulletinCardId = () => useSubjectSnapshot(BulletinCardIdSnapshot, () => BulletinCardIdSnapshot.getValue());
export const useDailyRaces = () => useSubjectSnapshot(DailyRacesSnapshot, () => DailyRacesSnapshot.getValue());
export const useHippodromesMap = () => useSubjectSnapshot(HippodromesMapSnapshot, () => HippodromesMapSnapshot.getValue());
export const useAvailableHippodromes = () => useSubjectSnapshot(AvailableHippodromes, () => AvailableHippodromes.getValue());
export const useAvailableFOBHippodromes = () => useSubjectSnapshot(AvailableFOBHippodromes, () => AvailableFOBHippodromes.getValue());
export const useAvailableLongtermHippodromes = () => useSubjectSnapshot(AvailableLongtermHippodromes, () => AvailableLongtermHippodromes.getValue());

export const getBulletin = () => BulletinSnapshot.getValue();
export const getBulletinCardId = () => BulletinCardIdSnapshot.getValue();
export const getDailyRaces = () => DailyRacesSnapshot.getValue();
export const getHippodromesMap = () => HippodromesMapSnapshot.getValue();
export const getAvailableHippodromes = () => AvailableHippodromes.getValue();
export const getAvailableFOBHippodromes = () => AvailableFOBHippodromes.getValue();

export function publishBulletinSnapshot(source: {
    bulletinMap: Record<string, any>;
    bulletinMapCardID: Record<string, any>;
    dailyRaces: any[];
    availableHippodromes: any[];
    availableFobHippodromes: any[];
    availableLongtermHippodromes: any[];
}) {
    BulletinSnapshot.next({...source.bulletinMap});
    BulletinCardIdSnapshot.next({...source.bulletinMapCardID});
    DailyRacesSnapshot.next([...source.dailyRaces]);
    AvailableHippodromes.next([...source.availableHippodromes]);
    AvailableFOBHippodromes.next([...source.availableFobHippodromes]);
    AvailableLongtermHippodromes.next([...source.availableLongtermHippodromes]);
}

export function publishHippodromesMap(hippodromesMap: Record<string, any>) {
    HippodromesMapSnapshot.next({...hippodromesMap});
}
